import PropTypes from "prop-types"
import React, { useState } from "react"
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { Col, Form, Label, Modal, ModalBody, Row, Input } from "reactstrap";
import * as CONSTANTS from "common/utils/data_validations"
import { MODE } from "helpers/sf_constants";
import Dropzone from "react-dropzone";
import { getPrimaryButtonClass, getPrimaryTextClass } from "helpers/sf_utils";
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert";


const UpdateRefundPolicyModal = ({ show: { active, mode, row }, onSubmitUpdatedState, onClickCloseModal }) => {

  const [selectedFile, setSelectedFile] = useState(null);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: mode === MODE.EDIT ? row?.id : null,
      name: mode === MODE.EDIT ? row?.name : "",
      description: mode === MODE.EDIT ? row?.description : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
      description: Yup.string().required(CONSTANTS.STR_REQUIRED_FIELD),
    }),
    onSubmit: (values, { resetForm }) => {
      onSubmitUpdatedState(mode, { ...values, active: values?.active?.value ? 1 : 0, url: selectedFile });
      resetForm();
    },
  });

  const handleFileUpload = (acceptedFiles) => {
    // condition to accept only one file else return
    if (acceptedFiles.length > 1) {
      ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: 'Please upload only one PDF file.' });
      return;
    }
    const file = acceptedFiles[0];
    // condition to accept only csv file else return
    if (file.type !== "application/pdf") {
      ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: 'Please upload PDF file only.' });
      return;
    }
    setSelectedFile(file);
    setIsFileSelected(true);
  };

  return (
    <Modal size="lg" isOpen={active} toggle={onClickCloseModal} centered={true}>
      <div className="modal-body" style={{ overflowY: "hidden" }}>
        <h5 className="modal-title d-flex align-items-center text-black font-weight-semibold mt-0" id="myModalLabel">
          <i className={`align-self-bottom label-title bx bx-receipt ${getPrimaryTextClass()} me-1`}></i>
          Refund Policy
        </h5>

        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onClickCloseModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <ModalBody style={{ overflowY: "hidden" }}>
        <Form onSubmit={(e) => {
          e.preventDefault()
          setIsFileSelected(false);
          validation.handleSubmit();
          return false;
        }}>
          <Row>
            <Col md={12}>
              <div className="mb-3">
                <Label htmlFor="name">Name</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name}
                  className={
                    validation.errors.name && validation.touched.name
                      ? "is-invalid"
                      : ""
                  }
                />
                {validation.errors.name && validation.touched.name && (
                  <div className="invalid-feedback">
                    {validation.errors.name}
                  </div>
                )}

              </div>
            </Col>
            <Col md={12}>
              <div className="mb-3">
                <Label htmlFor="name">Description</Label>
                <Input
                  type="textarea"
                  id="description"
                  name="description"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.description}
                  className={
                    validation.errors.description && validation.touched.description
                      ? "is-invalid"
                      : ""
                  }
                />
                {validation.errors.description && validation.touched.description && (
                  <div className="invalid-feedback">
                    {validation.errors.description}
                  </div>
                )}

              </div>
            </Col>
            <Col xs={12}>
              <Label htmlFor="name">Refund Policy File</Label>
              {selectedFile?.name ? (
                <div className="d-flex align-items-center">
                  <i className="bx bx-file me-1 font-size-16 text-black" />
                  <span className="text-black">{selectedFile.name}</span>

                  <a onClick={() => { setSelectedFile(null); setIsFileSelected(false); }} className="ms-3 text-danger font-size-14">
                    <span aria-hidden="true">&times;</span>
                  </a>
                </div>
              ) : (<Dropzone onDrop={handleFileUpload}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <div className='p-5 sf-file-input-dropzone'>
                      <i style={{ fontSize: '40px' }} className={`bx bx-upload align-middle mb-2 ${getPrimaryTextClass()}`} />
                      <p> Drag and drop a PDF file here, or click to select file</p>
                    </div>
                  </div>
                )}
              </Dropzone>)}
            </Col>
            <Col md={12}>
              <div className="mt-4 float-end">
                <button className={`btn ${getPrimaryButtonClass()} w-md`} disabled={!isFileSelected} type="submit" name="submit">
                  {mode === MODE.EDIT ? "Update" : "Save"}
                </button>
                <button type="button" className="btn btn-light ms-2" name="close" onClick={onClickCloseModal}>
                  Cancel
                </button>
              </div>
            </Col>
          </Row>

        </Form>
      </ModalBody>
    </Modal>
  )
}

UpdateRefundPolicyModal.propTypes = {
  onClickCloseModal: PropTypes.func,
  show: PropTypes.object,
}

export default UpdateRefundPolicyModal;
